export const replaceTag = (text, clientkey) => {
  if(!text) return text;
  return text
    .toString()
    .replace(/\[clientkey\]/gi, clientkey)
    .replace(/\[badgeno\]/gi, clientkey);
};
